module.exports = __webpack_public_path__ + "img/Testaments_4.png";